import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, Form, OverlayTrigger, Row, Spinner, Tooltip, Alert } from 'react-bootstrap';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { addClient } from 'functions/client';
import { toastMessageBox } from 'components/ToastifyMessage';
import AppContext from 'context/Context';
import * as XLSX from 'xlsx';

const AddClient=({})=>{

const navigate = useNavigate();
  const location = useLocation();
  const { id, saveType } = useParams();

    const clientData = location.state;


const [customerCode,setCustomerCode]=useState({value:null,options:{isRequired:true,label:'CustomerCode',isValidated:true,isTouched:false}});
const [companyName,setCompanyName]=useState({value:null,options:{isRequired:true,label:'CompanyName',isValidated:true,isTouched:false}});
const [companyAddress,setCompanyAddress]=useState({value:null,options:{isRequired:true,label:'CompanyAddress',isValidated:true,isTouched:false}});
const [companyTel,setCompanyTel]=useState({value:null,options:{isRequired:true,label:'CompanyTel',isValidated:true,isTouched:false}});

const formFields = [
  { name: 'customerCode', getField: customerCode, setField: setCustomerCode },
  { name: 'companyName', getField: companyName, setField: setCompanyName },
  { name: 'companyAddress', getField: companyAddress, setField: setCompanyAddress },
  { name: 'companyTel', getField: companyTel, setField: setCompanyTel },
];

const [userId,setUserId]=useState(null);
const [formTitle,setFormTitle]=useState(null);
const [tableId,setTableId]=useState(null);
const [isActive, setIsActive] = useState(true);

const { config } = useContext(AppContext);
  const { isDark } = config;
  const textColor = isDark ? '#fff' : '#212529';

useEffect(()=>{
  setUserId(JSON.parse(localStorage.getItem('userId')));
},[])

useEffect(()=>{
  console.log('iiii',id,saveType )
  if(saveType==="I"){
    setFormTitle("Add New Client");
    setIsActive(true); // default to active on add
  }
  else if (saveType === "U" && clientData) {
    setCustomerCode({ ...customerCode, value: clientData.customerCode });
    setCompanyName({ ...companyName, value: clientData.companyName });
    setCompanyAddress({ ...companyAddress, value: clientData.companyAddress });
    setCompanyTel({ ...companyTel, value: clientData.companyTel });
    setIsActive(clientData.isActive !== undefined ? clientData.isActive : true);
  }
},[saveType, clientData]);


  const [showSubmitted,setShowSubmitted]=useState(false);
  const [isLoading,setIsLoading]=useState(false);
  const [profilePicRead,setProfilePicRead]=useState(null);

  // Excel import states
  const [excelFile, setExcelFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [showExcelImport, setShowExcelImport] = useState(false);
  const [importProgress, setImportProgress] = useState(0);
  const [isImporting, setIsImporting] = useState(false);
  const [importResults, setImportResults] = useState({ success: 0, failed: 0, errors: [] });



  const loadUserbyUserId = async (id) => {
    try{
      const token=localStorage.getItem('token');
    const res = await getUserbyUserId(id,token);
   
    const {CustomerCode,CompanyName,CompanyAddress,CompanyTel}=res;
      setCustomerCode({ ...customerCode, value: CustomerCode });
      setCompanyName({ ...companyName, value: CompanyName });
      setCompanyAddress({ ...companyAddress, value: CompanyAddress });
      setCompanyTel({ ...companyTel, value: CompanyTel });
  }
  catch(err){
    console.log('Error',err);
  }
  };


  

  useEffect(() => {


  }, []);

  const [companiesOps,setCompaniesOps]=useState(null);        
  const [countriesops,setCountriesOps]=useState(null);
  const [rolesOps,setRolesOps]=useState(null);

  const [iud,setIud]=useState("I");





const closeSubmittedPanel=()=>{
setShowSubmitted(false);
}
  const onSubmitData = async event => {
    const uid = iud;
    event.preventDefault();
    try {
      setIsLoading(true);
      let inValidCount = 0;
      // setAttachments([]);
      formFields.map(f => {
        const isValidated = setFieldValues(f.getField.value, f.name);
        if (!isValidated) {
          inValidCount += 1;
        }
      });

      if (inValidCount > 0) {
        setIsLoading(false);
        return;
      }
      setShowSubmitted(true);
      // if(password!==confirmPassword){
      //   message('Success', "Confirm password doen't match", 'success');
      //   return;
      // }

      //const fileUploadObjs=[];

      // Array.from(attachments).forEach(attachment => {
      //   fileUploadObjs.push({fileNo:attachment.fileNo,size:attachment.size,type:attachment.type,name:attachment.name});
      // });

      // console.log('fileUploadObjs-----', fileUploadObjs);

      const data = {
        companyMasterId: id ,
        customerCode: customerCode.value,
        companyName: companyName.value,
        companyAddress: companyAddress.value,
        companyTel: companyTel.value,
        companyNo: "123",
        roleId: 2,
        uid: saveType,
        isAvailable: isActive // Add isAvailable field based on isActive state
  
      };
      console.log('data to submit', data);
      console.log('token', token);

      const token = localStorage.getItem('token');
      const res = await addClient(data, token);
      console.log('date to submit', res);

      // Handle case where backend returns an error string instead of expected object
      let responseStatus, outputMessage;
      if (res.data && typeof res.data === 'object' && res.data.output) {
        ({ responseStatus, outputMessage } = res.data.output);
      } else if (typeof res.data === 'string') {
        responseStatus = 'failed';
        outputMessage = res.data || 'An unknown error occurred.';
      } else {
        responseStatus = 'failed';
        outputMessage = 'An unknown error occurred.';
      }

      if (responseStatus === 'failed') {
        toastMessageBox('Exception', outputMessage, 'danger');
        setIsLoading(false);
        return;
      }

      toastMessageBox('Success', outputMessage, 'success');
      navigate(-1);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log('Error:', err);
    }
  };

const setFieldValues=(value,name)=>{

  console.log('setFieldValues name :', name,value);
  let isValidated=true;
   {formFields.map(f=>{
    const {getField}={...f};

if(f.name===name){
    getField.value=value;
    const options=getField.options;
    if (getField.options.isRequired) {
      // if (value === null || value.trim().length === 0) {
      //   options.isValidated = false;
      //   isValidated = false;
      //   console.log(name + ' vaidated : false');
      // } else {
      //   options.isValidated = true;
      //   isValidated = true;
      //   console.log(name + ' vaidated : true');
      // }

      if (value === null || (typeof value === 'string' && value.trim().length === 0) || (typeof value === 'number' && isNaN(value))) {
        options.isValidated = false;
        isValidated = false;
        console.log(name + ' validated: false');
      } else {
        options.isValidated = true;
        isValidated = true;
        console.log(name + ' validated: true');
      }
    }
    options.isTouched=true;

    f.setField({ ...f[name], ...getField });
}
  })}

  return isValidated;
}

// Excel import functions
const handleExcelFileUpload = (event) => {
  const file = event.target.files[0];
  if (file) {
    setExcelFile(file);
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '' });
      
      console.log('Raw Excel data:', jsonData); // Debug log
      
      // Process the data
      const processedData = [];
      console.log('Excel jsonData:', jsonData); // Debug log
      
      for (let i = 1; i < jsonData.length; i++) { // Skip header row
        const row = jsonData[i];
        console.log(`Row ${i}:`, row); // Debug log
        
        // Check if row has minimum required data (company name and customer code)
        if (row && row.length > 0 && row[0] && row[1]) {
          const processedRow = {
            companyName: row[0]?.toString().trim() || '',
            customerCode: row[1]?.toString().trim() || '',
            companyAddress: row[2]?.toString().trim() || '',
            companyTel: ''
          };
          
          // Handle Tel column - it might be in position 3 or 4 depending on Excel format
          if (row[3] !== undefined && row[3] !== null && row[3] !== '') {
            processedRow.companyTel = row[3]?.toString().trim() || '';
          } else if (row[4] !== undefined && row[4] !== null && row[4] !== '') {
            processedRow.companyTel = row[4]?.toString().trim() || '';
          }
          
          console.log('Processed row:', processedRow); // Debug log
          processedData.push(processedRow);
        }
      }
      setExcelData(processedData);
    };
    reader.readAsArrayBuffer(file);
  }
};

const handleBulkImport = async () => {
  if (excelData.length === 0) {
    toastMessageBox('Warning', 'No data to import', 'warning');
    return;
  }

  setIsImporting(true);
  setImportProgress(0);
  let successCount = 0;
  let failedCount = 0;
  const errors = [];

  const token = localStorage.getItem('token');

  for (let i = 0; i < excelData.length; i++) {
    const clientData = excelData[i];
    try {
      const data = {
        companyMasterId: null,
        customerCode: clientData.customerCode,
        companyName: clientData.companyName,
        companyAddress: clientData.companyAddress,
        companyTel: clientData.companyTel,
        companyNo: "123",
        roleId: 2,
        uid: "I", // Insert mode
        isAvailable: true
      };

      const res = await addClient(data, token);
      
      let responseStatus, outputMessage;
      if (res.data && typeof res.data === 'object' && res.data.output) {
        ({ responseStatus, outputMessage } = res.data.output);
      } else if (typeof res.data === 'string') {
        responseStatus = 'failed';
        outputMessage = res.data || 'An unknown error occurred.';
      } else {
        responseStatus = 'failed';
        outputMessage = 'An unknown error occurred.';
      }

      if (responseStatus === 'failed') {
        failedCount++;
        errors.push(`Row ${i + 2}: ${outputMessage}`);
      } else {
        successCount++;
      }
    } catch (error) {
      failedCount++;
      errors.push(`Row ${i + 2}: ${error.message || 'Unknown error'}`);
    }

    // Update progress
    setImportProgress(((i + 1) / excelData.length) * 100);
  }

  setImportResults({ success: successCount, failed: failedCount, errors });
  setIsImporting(false);
  
  if (successCount > 0) {
    toastMessageBox('Success', `Import completed. ${successCount} clients added successfully.`, 'success');
  }
  if (failedCount > 0) {
    toastMessageBox('Warning', `${failedCount} clients failed to import. Check the results for details.`, 'warning');
  }
};

const resetExcelImport = () => {
  setExcelFile(null);
  setExcelData([]);
  setShowExcelImport(false);
  setImportProgress(0);
  setIsImporting(false);
  setImportResults({ success: 0, failed: 0, errors: [] });
};

const ticketForm=()=>{
 return (
   <Card className="mb-3">
     <Card.Header className="bg-light" style={{ color: textColor, background: isDark ? '#23272b' : undefined }}>
       <div className="d-flex justify-content-between align-items-center">
         <h5 className="mb-0" style={{ color: textColor }}>{formTitle}</h5>
         {saveType === "I" && (
           <Button 
             variant="outline-primary" 
             size="sm"
             onClick={() => setShowExcelImport(!showExcelImport)}
           >
             {showExcelImport ? 'Hide' : 'Show'} Excel Import
           </Button>
         )}
       </div>
     </Card.Header>
     
     {/* Excel Import Section */}
     {showExcelImport && saveType === "I" && (
       <Card.Body className="border-bottom" style={{ color: textColor, background: isDark ? '#2c3034' : '#f8f9fa' }}>
         <h6 className="mb-3" style={{ color: textColor }}>Bulk Import Clients from Excel</h6>
         
         <Row>
           <Col md={6}>
             <Form.Group className="mb-3">
               <Form.Label style={{ color: textColor }}>Select Excel File</Form.Label>
               <Form.Control
                 type="file"
                 accept=".xlsx,.xls"
                 onChange={handleExcelFileUpload}
               />
               <Form.Text className="text-muted">
                 Expected format: Company Name | Customer Code | Company Address | Company Tel
               </Form.Text>
             </Form.Group>
             
             {excelData.length > 0 && (
               <div className="mb-3">
                 <Alert variant="info">
                   <strong>{excelData.length} clients</strong> ready to import
                 </Alert>
                 
                 <div className="d-flex gap-2">
                   <Button
                     variant="success"
                     onClick={handleBulkImport}
                     disabled={isImporting}
                   >
                     {isImporting ? (
                       <>
                         <Spinner size="sm" className="me-2" />
                         Importing... ({Math.round(importProgress)}%)
                       </>
                     ) : (
                       'Import All Clients'
                     )}
                   </Button>
                   
                   <Button
                     variant="outline-secondary"
                     onClick={resetExcelImport}
                     disabled={isImporting}
                   >
                     Reset
                   </Button>
                 </div>
               </div>
             )}
           </Col>
           
           <Col md={6}>
             {excelData.length > 0 && (
               <div>
                 <h6 style={{ color: textColor }}>Preview (First 5 rows)</h6>
                 <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                   <table className="table table-sm">
                     <thead>
                       <tr>
                         <th>Company Name</th>
                         <th>Customer Code</th>
                         <th>Address</th>
                         <th>Tel</th>
                       </tr>
                     </thead>
                     <tbody>
                       {excelData.slice(0, 5).map((client, index) => (
                         <tr key={index}>
                           <td>{client.companyName}</td>
                           <td>{client.customerCode}</td>
                           <td>{client.companyAddress}</td>
                           <td>{client.companyTel}</td>
                         </tr>
                       ))}
                     </tbody>
                   </table>
                 </div>
               </div>
             )}
           </Col>
         </Row>
         
         {/* Import Results */}
         {importResults.success > 0 || importResults.failed > 0 ? (
           <Alert variant={importResults.failed > 0 ? "warning" : "success"} className="mt-3">
             <strong>Import Results:</strong> {importResults.success} successful, {importResults.failed} failed
             {importResults.errors.length > 0 && (
               <details className="mt-2">
                 <summary>Error Details</summary>
                 <ul className="mb-0 mt-2">
                   {importResults.errors.map((error, index) => (
                     <li key={index}>{error}</li>
                   ))}
                 </ul>
               </details>
             )}
           </Alert>
         ) : null}
       </Card.Body>
     )}
     <Card.Body className="bg-light" style={{ color: textColor, background: isDark ? '#23272b' : undefined }}>
       <style>{`
         .add-client-label { color: ${textColor} !important; }
       `}</style>
      <Row className="gx-2 gy-3">
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-client-label">
               Customer Code
               {customerCode.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValues(e.target.value, 'customerCode');
                 }}
                 value={customerCode.value}
               />
               {!customerCode.options.isValidated && customerCode.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${customerCode.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>

         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-client-label">
               Company Name
               {companyName.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValues(e.target.value, 'companyName');
                 }}
                 value={companyName.value}
               />
               {!companyName.options.isValidated && companyName.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${companyName.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>

     
         <Col sm="4">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-client-label">
               Tel No
               {companyTel.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValues(e.target.value, 'companyTel');
                 }}
                 value={companyTel.value}
               />
               {!companyTel.options.isValidated && companyTel.options.isTouched && (
                 <p
                   className="text-danger"
                   style={{ marginLeft: '10px' }}
                 >{`${companyTel.options.label} is required`}</p>
               )}
             </Col>
           </Form.Group>
         </Col>
   
       </Row>

       <Row className="gx-2 gy-3">
         <Col sm="12">
           <Form.Group
             as={Row}
             className="mb-3"
             controlId="formPlaintextSubject"
           >
             <Form.Label sm="12" className="add-client-label">
             Company Address
               {companyAddress.options.isRequired && (
                 <span className="text-danger">*</span>
               )}
             </Form.Label>
             <Col sm="12">
               <Form.Control
                 type="text"
                 placeholder=""
                 onChange={e => {
                   setFieldValues(e.target.value, 'companyAddress');
                 }}
                 value={companyAddress.value}
               />
               {!companyAddress.options.isValidated &&
                 companyAddress.options.isTouched && (
                   <p
                     className="text-danger"
                     style={{ marginLeft: '10px' }}
                   >{`${companyAddress.options.label} is required`}</p>
                 )}
             </Col>
           </Form.Group>
         </Col>


       </Row>

       {/* Only show Active Status when updating (saveType === 'U') */}
       {saveType === 'U' && (
         <Row className="gx-2 gy-3">
           <Col sm="12">
             <Form.Group as={Row} className="mb-3" controlId="formActiveStatus">
               <Form.Label column sm="12" className="add-client-label">
                 Active Status
               </Form.Label>
               <Col sm="12">
                 <div className="d-flex align-items-center gap-3">
                   <Form.Check
                     type="checkbox"
                     label="Active"
                     checked={isActive}
                     onChange={e => setIsActive(e.target.checked)}
                   />
                   <Form.Check
                     type="checkbox"
                     label="Inactive"
                     checked={!isActive}
                     onChange={e => setIsActive(!e.target.checked)}
                   />
                 </div>
               </Col>
             </Form.Group>
           </Col>
         </Row>
       )}

       <Row>
         <Col xs="12">
           <div className="text-center" style={{ marginTop: '40px' }}>
             <Button
               variant="success"
               size="lg"
               className="me-2 mb-1"
               onClick={onSubmitData}
               disabled={isLoading}
             >
               {isLoading ? (
                 <>
                   {' '}
                   <Spinner
                     as="span"
                     animation="grow"
                     size="sm"
                     role="status"
                     aria-hidden="true"
                   />{' '}
                   Saving...
                 </>
               ) : (
                 'Save'
               )}
             </Button>
           </div>
         </Col>
       </Row>
     </Card.Body>
   </Card>
 );
}
      return <>{ticketForm()}</>;
   

}

export default AddClient;